import { privateClient } from '../axiosClients/axiosClients';
import { getDownloadLink } from '../utils';

function getTimeStamp() {
  const date = new Date();
  const timestamp = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
  return timestamp;
}

export async function downloadPECRExcelList(body) {
  const response = await privateClient.post(
    'DownloadExcelforPECRList',
    {
      ...body,
    },
    { responseType: 'blob' }
  );
  const timestamp = getTimeStamp();
  getDownloadLink(response.data, `PECR_List_${timestamp}.xlsx`);
}

export async function downloadDetailedList(body) {
  const response = await privateClient.post(
    'ReportExcelforPECRList',
    { ...body },
    { responseType: 'blob' }
  );
  const timestamp = getTimeStamp();
  getDownloadLink(response.data, `PECR_Detailed_List_${timestamp}.xlsx`);
}
